module.exports = __webpack_public_path__ + "static/media/login_footer.81f4baca.png";